<div class="pens-container">
    <div class="header">
        <!-- <span>Manage all your  pen tests to keep your websites and services secure. </span> -->
        <div class="actions">
            <div class="search-input-container">
                <i class="fa-solid fa-magnifying-glass" style="opacity: 0.9; color: #289DD2;"></i>
                <input type="text" (input)="onSearchChange()" [(ngModel)]="searchQuery" placeholder="Search domains..." 
                    class="search-input" />
                <i *ngIf="searchQuery" class="fa-solid fa-xmark clear-search" 
                   style="opacity: 0.8; cursor: pointer; color: #289DD2; margin-left: 5px;" 
                   (click)="searchQuery = ''; onSearchChange()"></i>
            </div>
            <button class="add-button" (click)="openModal()">
                <i class="fa-solid fa-plus" style="margin-right: 8px;"></i>Add New
            </button>
        </div>
    </div>
    <div class="table-container">
        <table class="pens-table">
            <thead>
                <tr>
                    <th>
                        <div class="th-content">
                            <i class="fa-solid fa-globe th-icon"></i>
                            <span>Domain</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <i class="fa-solid fa-network-wired th-icon"></i>
                            <span>Network</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <i class="fa-solid fa-lock th-icon"></i>
                            <span>SSL</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <i class="fa-solid fa-sitemap th-icon"></i>
                            <span>DNS</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <i class="fa-solid fa-id-card th-icon"></i>
                            <span>WHOIS</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <i class="fa-solid fa-shield-halved th-icon"></i>
                            <span>Security</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <i class="fa-regular fa-clock th-icon"></i>
                            <span>Last Tested</span>
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <i class="fa-solid fa-gears th-icon"></i>
                            <span>Actions</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="pens.length > 0; else noPens">
                    <tr *ngFor="let pen of filteredPens">
                        <td style="font-weight: 500;">{{ pen?.domain }}</td>
                        <td *ngIf="pen?.status == 'PENDING'" colspan="7" style="font-style: italic; opacity: 0.9;">Analyzing vulnerabilities... Stay tuned for
                            updates.</td>
                        <ng-container *ngIf="pen?.status == 'READY'">
                            <td>
                                <i [ngClass]="pen?.report?.networkScanning?.status == 'pass' ? 'fa-regular fa-circle-check':  'fa-regular fa-circle-xmark text-red-500'" style="font-size: 20px;" [style]="pen?.report?.networkScanning?.status != 'pass' ? 'color:#ff4d4d': 'color:#4caf50'"></i>
                                <i *ngIf="pen?.report?.networkScanning?.status != 'pass'"
                                   class="fa-regular fa-circle-question"
                                   style="margin-left: 6px; cursor: pointer; padding: 5px; opacity: 0.7;"
                                   [title]="pen?.report?.networkScanning?.reason + '\n\nSolution:\n' + pen?.report?.networkScanning?.recommendation">
                                </i>
                            </td>
                            <td>
                                <i [ngClass]="pen?.report?.cipherSuite?.status == 'pass' ? 'fa-regular fa-circle-check':  'fa-regular fa-circle-xmark text-red-500'" style="font-size: 20px;" [style]="pen?.report?.cipherSuite?.status != 'pass' ? 'color:#ff4d4d': 'color:#4caf50'"></i>
                                <i *ngIf="pen?.report?.cipherSuite?.status != 'pass'"
                                   class="fa-regular fa-circle-question"
                                   style="margin-left: 6px; cursor: pointer; padding: 5px; opacity: 0.7;"
                                   [title]="pen?.report?.cipherSuite?.reason + '\n\nSolution:\n' + pen?.report?.cipherSuite?.recommendation">
                                </i>
                            </td>
                            <td>
                                <i [ngClass]="pen?.report?.dnsEnumeration?.status == 'pass' ? 'fa-regular fa-circle-check':  'fa-regular fa-circle-xmark text-red-500'" style="font-size: 20px;" [style]="pen?.report?.dnsEnumeration?.status != 'pass' ? 'color:#ff4d4d': 'color:#4caf50'"></i>
                                <i *ngIf="pen?.report?.dnsEnumeration?.status != 'pass'"
                                   class="fa-regular fa-circle-question"
                                   style="margin-left: 6px; cursor: pointer; padding: 5px; opacity: 0.7;"
                                   [title]="pen?.report?.dnsEnumeration?.reason + '\n\nSolution:\n' + pen?.report?.dnsEnumeration?.recommendation">
                                </i>
                            </td>
                            <td>
                                <i [ngClass]="pen?.report?.whoisLookup?.status == 'pass' ? 'fa-regular fa-circle-check':  'fa-regular fa-circle-xmark text-red-500'" style="font-size: 20px;" [style]="pen?.report?.whoisLookup?.status != 'pass' ? 'color:#ff4d4d': 'color:#4caf50'"></i>
                                <i *ngIf="pen?.report?.whoisLookup?.status != 'pass'"
                                   class="fa-regular fa-circle-question"
                                   style="margin-left: 6px; cursor: pointer; padding: 5px; opacity: 0.7;"
                                   [title]="pen?.report?.whoisLookup?.reason + '\n\nSolution:\n' + pen?.report?.whoisLookup?.recommendation">
                                </i>
                            </td>
                            <td>
                                <i [ngClass]="pen?.report?.securityHeaders?.status == 'pass' ? 'fa-regular fa-circle-check':  'fa-regular fa-circle-xmark text-red-500'" style="font-size: 20px;" [style]="pen?.report?.securityHeaders?.status != 'pass' ? 'color:#ff4d4d': 'color:#4caf50'"></i>
                                <i *ngIf="pen?.report?.securityHeaders?.status != 'pass'"
                                   class="fa-regular fa-circle-question"
                                   style="margin-left: 6px; cursor: pointer; padding: 5px; opacity: 0.7;"
                                   [title]="pen?.report?.securityHeaders?.reason + '\n\nSolution:\n' + pen?.report?.securityHeaders?.recommendation">
                                </i>
                            </td>
                            <!-- <td>
                            <i [ngClass]="pen?.report?.sslConfiguration?.status == 'pass' ? 'fa-regular fa-circle-check':  'fa-regular fa-circle-xmark text-red-500'" style="font-size: 24px;" [style]="pen?.report?.sslConfiguration?.status != 'pass' ? 'color:red': 'color:green'"></i>
                            <i *ngIf="pen?.report?.sslConfiguration?.status != 'pass'"
                                                               class="fa-regular fa-circle-question opacity-50"
                                                               style="margin-left: 5px; cursor: pointer; padding: 5px;"
                                                               [title]="pen?.report?.sslConfiguration?.reason + '\n\nSolution:\n' + pen?.report?.sslConfiguration?.recommendation">
                                                            </i>
                        </td> -->
                            <td style="opacity: 0.9; font-size: 14px;">{{ pen?.updatedAt | date: 'MMM dd, yyyy hh:mm:ss' }}</td>
                        </ng-container>

                        <td class="h-[55px]" >
                            <button *ngIf="pen?.status == 'READY'"
                                class="px-4 py-[5px] rounded-full bg-transparent text-[#289DD2] hover:font-bold hover:border-2 hover:px-3 hover:py-[3px]  transition duration-300 border border-[#289DD2] mx-1"
                                style="font-size: 14px; cursor: pointer; letter-spacing: 0.3px;" (click)="retestPen(pen?.domain)">
                                Re-test
                            </button>
                            <button *ngIf="pen?.status == 'READY'"
                                class="px-4 py-[5px] rounded-full bg-transparent text-[#289DD2] hover:font-bold hover:border-2 hover:px-3 hover:py-[3px]  transition duration-300 border border-[#289DD2] mx-1"
                                style="font-size: 14px; cursor: pointer; letter-spacing: 0.3px;" (click)="viewReport(pen)">
                                View Report
                            </button>
                        </td>

                    </tr>
                </ng-container>
                <ng-template #noPens>
                    <tr>
                        <td colspan="8" class="no-pens-message">
                            {{ noPensMessage }}
                        </td>
                    </tr>
                </ng-template>
            </tbody>
        </table>
    </div>
    <div *ngIf="isModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-black p-6 rounded-lg shadow-lg w-96 border border-gray-700">
            <h2 class="text-white text-lg font-semibold mb-4">Enter Domain</h2>
            <div *ngIf="errMsg" class="text-red-500 mt-1 text-sm">
                {{ errMsg }}
            </div>

            <!-- Form to enter domain -->
            <form (ngSubmit)="saveDomain()">

                <div class="mb-4">
                    <!-- <label for="domain" class="text-gray-200 block mb-2">Enter Domain:</label> -->
                    <input type="text" id="domain" [(ngModel)]="domain" name="domain" required
                        class="w-full px-3 py-2 rounded border border-gray-600 bg-gray-800 text-white focus:outline-none focus:border-[#289DD2]">
                </div>

                <div class="flex justify-end space-x-2">
                    <button type="button"
                        class="bg-transparent border border-[#289DD2] text-[#289DD2] px-4 py-2 rounded opacity-70"
                        (click)="closeModal()">
                        Close
                    </button>
                    <button type="submit" class="bg-[#289DD2] text-white px-4 py-2 rounded hover:bg-[#289DD2]">
                        Test
                    </button>
                </div>
            </form>
        </div>
    </div>

    <!-- Report Modal -->
    <div>
        <app-pen-report *ngIf="userPen" [userPen]="userPen" (closeReport)="closeReport()"></app-pen-report>
    </div>




</div>
